import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { TreeService } from '../LayerControlPage/TreeService';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';

class LayerTypeCreateComponent extends Component {
    toast = null;
    constructor(props) {
        super(props);
        this.toast = React.createRef();
        this.state = {
            column: {
                type: '',
                name: '',
            },
            tableName:'',
            data: [],
            columnTypes: [],
            selectedDropdown: null
        };
    }

    handleInputChange = (e, field) => {
        const { column } = this.state;
        this.setState({
            column: { ...column, [field]: e.target.value },
        });
    };

    handleInputChangeDropdown = (e, field) => {
        const { column } = this.state;
        this.setState({
            column: { ...column, [field]: e.target.value.name },
            selectedDropdown: e.value
        });
    };

    handleChangeName = (e) => {
        this.setState({ tableName: e.target.value });
    }

    handleAddItem = () => {
        const { column, data } = this.state;
        this.setState({
            data: [...data, column],
            column: {
                type: '',
                name: '',
            },
            selectedDropdown: null
        });
    };

    handleRemoveItem = (rowData) => {
        const updatedData = this.state.data.filter(item => item !== rowData);
        this.setState({ data: updatedData });
    };

    handleSave = () => {
        // Implement your save logic here, for example, send data to the server or update the database
        console.log('Save button clicked! Data:', this.state.data);

        if (!this.state.tableName) {
            this.toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Tablo Adı Bulunamadı' });
        }

        let data = {
            columns: this.state.data,
            name: this.state.tableName,
            userId: 0,
            tableType:1
        }

        console.log(data);

        TreeService.createTreeTable(data).then(res => {
            if (res.success) {
                this.toast.current.show({ severity: 'info', summary: 'Bilgi', detail: 'Tablo ekleme başarılı' });
            }
        })

    };

    componentDidMount() {
        TreeService.getColumnsTypes().then(res => {
            if (!res.success) {
                this.toast.current.show({ severity: 'error', summary: 'Hata', detail: 'Kolon Tipleri Getirilemedi.' });
            }
            this.setState({ columnTypes: res.data })

        })
    }

    render() {
        const { column, data, tableName, columnTypes, selectedDropdown } = this.state;

        return (
            <div className="add-page">
                <h1>Tablo Oluşturma Sayfası</h1>
                <div style={{ maxWidth: '200px' }}>
                    <div className="flex flex-column gap-2">
                        <label htmlFor="tableName">Tablo İsmi</label>
                        <InputText
                            id="tableName"
                            value={tableName}
                            onChange={(e) => this.handleChangeName(e)}
                        />
                    </div>

                    <div className="flex flex-column gap-2">
                        <label>Kolon İsmi:</label>
                        <InputText
                            value={column.name}
                            onChange={(e) => this.handleInputChange(e, 'name')}
                        />
                    </div>

                    <div className="flex flex-column gap-2">
                        <label>Kolon Tipi</label>

                        <Dropdown value={selectedDropdown} onChange={(e) => this.handleInputChangeDropdown(e, 'type')} options={columnTypes} optionLabel="name"
                            placeholder="Kolon Tipi" className="w-full md:w-14rem" />
                    </div>

                </div>

                <div className="col-md-12 mt-4">
                    <Button label="Kolon Ekle" onClick={this.handleAddItem} />
                </div>
                <div className="data-table-section">
                    <DataTable value={data}>
                        <Column field="name" header="Kolon İsmi" />
                        <Column field="type" header="Kolon Tipi" />
                        <Column header="İşlem" body={(rowData) => (
                            <Button label="Remove" icon="pi pi-trash" onClick={() => this.handleRemoveItem(rowData)} />
                        )} />
                    </DataTable>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12 mt-4">
                            <Button label="Kaydet" className="p-button-success" onClick={this.handleSave} />
                        </div>
                    </div>
                </div>
                <Toast ref={this.toast} />
            </div>
        );
    }
}

export default LayerTypeCreateComponent;